import { useState, useEffect } from "react";
import { TablePagination } from "@material-ui/core";

import { lang } from "../i18nLang";

interface IProps {
  rowsPerPageOptions: number[];
  rowsCount: number;
}

const useTablePagination = ({ rowsPerPageOptions, rowsCount }: IProps) => {
  const customRowsPerPageOptions = rowsPerPageOptions || [5, 10, 25];
  const [count, setCount] = useState(rowsCount || 0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(customRowsPerPageOptions[0]);

  useEffect(() => {
    setCount(rowsCount || 0);
  }, [rowsCount]);

  function goToFirstPage() {
    setPage(0);
  }

  function handleChangePage(event, newPage: number) {
    setPage(newPage);
  }

  function handleChangeRowsPerPage(event) {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  }

  function handleLabelDisplayedRows({ from, to, count }): string {
    return `${from}-${to} de ${count !== -1 ? count : `mais que ${to}`}`;
  }

  function getPaginatedList(list: any[]): any[] {
    const pageStartIndex = page * rowsPerPage;
    const pageEndIndex = page * rowsPerPage + rowsPerPage;
    return list.slice(pageStartIndex, pageEndIndex);
  }

  return {
    getPaginatedList,
    goToFirstPage,
    Pagination: () => (
      <TablePagination
        rowsPerPageOptions={customRowsPerPageOptions}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        style={{ width: "100%" }}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={handleLabelDisplayedRows}
        labelRowsPerPage={lang("pagination.rowsPerPage")}
        backIconButtonText={lang("pagination.backText")}
        nextIconButtonText={lang("pagination.nextText")}
      />
    ),
  };
};

export default useTablePagination;
